import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "cacheable-page-checklist"
    }}>{`Cacheable page checklist`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Pages use GET requests`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Pages render only cacheable blocks`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Pages render without sensitive private data; session and customer DTO objects are empty`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Functionality specific to both current session (customer) and page should be written using JavaScript (e.g., related product listing should exclude items that are already in the shopping cart)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Model and block level should identify themselves for invalidation support`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Declare a custom `}<a parentName="p" {...{
            "href": "/commerce/php/src/pages/development/cache/page/public-content.md#configure-page-variations"
          }}>{`context variable`}</a>{` if you plan to show different public content with the same URL`}</p>
      </li>
    </ul>
    <h2 {...{
      "id": "non-cacheable-page-checklist"
    }}>{`Non-cacheable page checklist`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Use POST requests to modify Magento state (e.g., adding to shopping cart, wishlist, etc.)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Blocks that can't be cached should be marked as non-cacheable in the layout. However, be aware that adding a non-cacheable block to a page prevents the full page cache from caching that page.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Controllers that don't use layouts should set `}<inlineCode parentName="p">{`no-cache`}</inlineCode>{` HTTP headers`}</p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      